import {
    CREATE_USER, 
    SELECT_USER, 
    FETCH_USERS_SUCCESS, 
    FETCH_USERS_FAILURE, 
    REQUEST_USERS 
} from '../actions/type'

const INITIAL_STATE = { all: [], currentUser: null, isLoading: true, error: null };

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case REQUEST_USERS:
            return { ...state, error: null, isLoading: true };
        case FETCH_USERS_SUCCESS:// return list of posts and make loading = false
            return { ...state, all: action.payload.data, error: null, isLoading: false };
        case FETCH_USERS_FAILURE:// return error and make loading = false
            const error = action.payload || { message: action.payload.message };//2nd one is network or server down errors
            return { ...state, all: [], error: error, isLoading: false };
        case CREATE_USER:
            return state;
        case SELECT_USER:
            return Object.assign({}, state, {
                currentUser: action.payload
            });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./master/jsx/reducers/users_reducer.js